import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const heroArticles = articles.slice(0, 3);

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex flex-col items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20warm%20crimson%20and%20gold%20artistic%20background%20with%20soft%20gradient%2C%20minimalist%20editorial%20style%2C%20warm%20toned%20atmosphere%2C%20subtle%20texture%2C%20cinematic%20mood%2C%20soft%20glow%20effect%2C%20elegant%20composition%2C%20no%20text%2C%20no%20people%2C%20abstract%20artistic%20wallpaper%20style%2C%20cream%20undertones&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="今日吃瓜背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 text-center pt-20 pb-10">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading text-white leading-tight mb-6">
            51 今日吃瓜
          </h1>
          <p className="text-xl md:text-2xl lg:text-3xl font-heading text-white/90 mb-4">
            全网热门大瓜
          </p>
          <p className="text-lg md:text-xl text-white/70 mb-10">
            实时聚合爆料
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Link
              to="/category/remen-dagua"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-white text-base font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              立即吃瓜 <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 rounded-full border-2 border-white/40 text-white text-base font-medium hover:bg-white/10 hover:border-white/60 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              我要爆料
            </Link>
          </div>
        </div>

        {/* Featured Cards Stack */}
        <div className="mt-12 md:mt-16 flex items-end justify-center gap-4 md:gap-6 perspective-[1200px]">
          {heroArticles.map((article, idx) => {
            const offsets = [
              'translate-y-0 -rotate-2 z-30',
              'translate-y-6 rotate-0 z-20',
              'translate-y-0 rotate-2 z-10',
            ];
            return (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className={`group w-[220px] md:w-[280px] rounded-2xl overflow-hidden bg-white shadow-lg hover:shadow-xl transition-all duration-300 ${offsets[idx]} hover:translate-y-[-4px] cursor-pointer`}
              >
                <div className="relative w-full h-40 md:h-48 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading={idx === 0 ? 'eager' : 'lazy'}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                  <span className="absolute top-3 right-3 px-2 py-0.5 rounded-full bg-primary-500 text-white text-xs font-bold">
                    {article.hotLevel === 'explosive' ? '爆' : article.hotLevel === 'hot' ? '热' : '新'}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-2 leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-2">{article.category}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}